// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".impersonate-banner[data-v-1bcabff4]{color:#fff;background-color:#e82c0c;padding:5px;text-align:center;width:100%;z-index:9999;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
